<template>
  <div class="main">
    <NavigationBar></NavigationBar>

    <main>
      <section class="page-section">
    <div class="overlay-load" v-if="isLoading">
            <div class="loader">
      <div class="progress-bar"></div>
    </div>
    <div class="overlay-text">{{ $t('ap1') }}</div>
    <div class="overlay-text">{{ $t('ap2') }}</div>
    <div class="overlay-text">{{ $t('ap3') }}</div>

  </div>
 <div class="container">
    <!-- 左侧聊天区 -->
    <div class="panel chat-panel">
      <div class="chat-container">
        <!-- 数据集管理区 -->
        <div class="dataset-panel">
          <h3 class="dataset-panel-title">{{ $t('ap8') }}</h3>
          
          <!-- 第一行：数据类型 + 数据集选择 + 类型 + 添加按钮 -->
          <div class="dataset-add-row">
            <select v-model="selectedDataType" class="dataset-select">
                <option disabled value="">{{ $t('ap9') }}</option>
                <option value="1">{{ $t('ap13') }}</option>
                <option value="2">{{ $t('ap14') }}</option>
                <option value="3">{{ $t('ap15') }}</option>
                <option value="4">{{ $t('ap16') }}</option>
            </select>
            
            <!-- 单细胞基础数据 -->
            <select v-if="selectedDataType === '1'" v-model="selectedId1" class="dataset-select">
                <option disabled value="">{{ $t('ap10') }}</option>
                <option v-for="dataset in SC_datasets" :key="dataset.id" :value="dataset.name">{{ dataset.name }}</option>
            </select>
            <select v-if="selectedDataType === '1'" v-model="selectedType1" class="dataset-select">
              <option value="umap">{{ $t('ap17') }}</option>
              <option value="差异">{{ $t('ap18') }}</option>
            </select>
            
            <!-- 单细胞基因表达量 -->
            <select v-if="selectedDataType === '2'" v-model="selectedId2" class="dataset-select">
                <option disabled value="">{{ $t('ap10') }}</option>
                <option v-for="dataset in SC_datasets" :key="dataset.id" :value="dataset.name">{{ dataset.name }}</option>
            </select>
            <select v-if="selectedDataType === '2'" v-model="selectedGene_SC" class="dataset-select">
              <option value="类型A">{{ $t('ap17') }}</option>
              <option value="类型C">{{ $t('ap18') }}</option>
            </select>
            
            <!-- 空转基础数据 -->
            <select v-if="selectedDataType === '3'" v-model="selectedId3" class="dataset-select">
                <option disabled value="">{{ $t('ap10') }}</option>
                <option v-for="dataset in ST_datasets" :key="dataset.id" :value="dataset.name">{{ dataset.name }}</option>
            </select>
            <select v-if="selectedDataType === '3'" v-model="selectedType2" class="dataset-select">
              <option value="空间位置">{{ $t('ap19') }}</option>
              <option value="差异">{{ $t('ap18') }}</option>
            </select>
            
            <!-- 空转基因表达量 -->
            <select v-if="selectedDataType === '4'" v-model="selectedId4" class="dataset-select">
                <option disabled value="">{{ $t('ap10') }}</option>
                <option v-for="dataset in ST_datasets" :key="dataset.id" :value="dataset.name">{{ dataset.name }}</option>
            </select>
            <select v-if="selectedDataType === '4'" v-model="selectedGene_ST" class="dataset-select">
              <option value="类型A">{{ $t('ap17') }}</option>
              <option value="类型C">{{ $t('ap18') }}</option>
            </select>
            
            <button v-if="selectedDataType === '1'" @click="addDataset(1)" class="add-btn" :disabled="!selectedId1 || !selectedType1">{{ $t('ap20') }}</button>
            <button v-if="selectedDataType === '2'" @click="addDataset(2)" class="add-btn" :disabled="!selectedId2 || !selectedGene_SC">{{ $t('ap20') }}</button>
            <button v-if="selectedDataType === '3'" @click="addDataset(3)" class="add-btn" :disabled="!selectedId3 || !selectedType2">{{ $t('ap20') }}</button>
            <button v-if="selectedDataType === '4'" @click="addDataset(4)" class="add-btn" :disabled="!selectedId4 || !selectedGene_ST">{{ $t('ap20') }}</button>
          </div>
          
          <div class="dataset-list-section">
            <h4>{{ $t('ap11') }}</h4>
            <div class="dataset-list">
              <div v-for="(ds, index) in datasets" :key="index" class="dataset-tag">
                {{ ds.id }} ({{ ds.type }})
                <span @click="removeDataset(index)" class="remove-tag">×</span>
              </div>
              <div v-if="datasets.length === 0" class="no-dataset">{{ $t('ap12') }}</div>
            </div>
          </div>
        </div>
        
        <!-- AI对话框 -->
        <div class="chat-messages">
            <h3 class="chat-title">{{ $t('ap21') }}</h3>
          <div v-for="(msg, index) in chatMessages" :key="index"
               class="message" :class="msg.role">
            <div class="message-content">{{ msg.content }}</div>
          </div>
        </div>
        <div class="chat-input-container">
        <div class="chat-input">
          <input v-model="userInput"
                @keyup.enter="sendMessage"
                :placeholder="$t('ap22')"
                 />
          <button @click="sendMessage" :class="{ 'stop-btn': isLoading2 }">
            {{ isLoading2 ? $t('ap24') : $t('ap23') }}
          </button>
        </div>
        </div>
        <!-- 快捷功能按钮 -->
        <div class="quick-actions">
          <button class="quick-btn" @click="sendQuickCommand('umap')">{{ $t('ap34') }}</button>
          <button class="quick-btn" @click="sendQuickCommand('spatial')">{{ $t('ap35') }}</button>
          <button class="quick-btn" @click="sendQuickCommand('histogram')">{{ $t('ap36') }}</button>
        </div>
      </div>
    </div>

    <!-- 右侧展示区 -->
    <div class="panel left-panel">
      <div class="preview-area">
        <div class="image-preview">
                <div ref="myCanvas" id="myCanvas" style="width: 100%; height: 100%;"></div>
        </div>
      </div>

    </div>
  </div>
  
  

      <!-- iOS风格模态窗 -->
      <div 
      v-if="showModal"
      ref="modalRef"
      class="context-modal"
      :style="modalPosition"
    >
      <div class="modal-header">
        <h3>AI 辅助编程</h3>
        <button class="close-btn" @click="closeModal">×</button>
      </div>
      
      <div class="modal-content">
        <div class="selected-code">
          <pre>{{ selectedCode }}</pre>
        </div>
        
        <div class="input-group">
          <textarea
            v-model="userInput2"
            placeholder="请输入你的问题或指令"
            class="ios-input"
          ></textarea>
          <button class="ios-button" @click="handleSubmit">发送</button>
        </div>
      </div>
  </div>
  
      </section>
    </main>
  </div>
</template>

<script setup>
import { ref,onMounted,watch } from 'vue'
//import {  computed, onUnmounted } from 'vue'

//----------以下为一个ssmood页面需要的最基础的东西--------------
import { useI18n } from 'vue-i18n';
//import LanguageSwitcher from './general/LanguageSwitcher.vue';
import NavigationBar from './general/NavigationBar.vue';
import config from '@/config';
const { t } = useI18n();
//----------以上为一个ssmood页面需要的最基础的东西--------------


const isLoading = ref(true);
isLoading.value = false;


import ace from 'ace-builds'
import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/theme-clouds'
import axios from 'axios';
import { TerminalApi } from 'vue-web-terminal';
import pako from 'pako';
import Plotly from 'plotly.js-dist-min';
// 终端相关
const terminalLogs = ref([])

const handleExe = async () => {
  try {
    const dynamicVariable = {}; // 用于存储加载的数据

    // 将每个数据集的加载逻辑包装为 Promise
    const fetchPromises = datasets.value.map(async (dataset) => {
      if (dataset.way == 1) {
        const params = new URLSearchParams({
          id: dataset.id
        });

        const response = await fetch(config.apiUrl + `scd_getumapdata.php?${params}`);
        const arrayBuffer = await response.arrayBuffer();

        const compressed = new Uint8Array(arrayBuffer);
        const decompressed = pako.ungzip(compressed); // 使用pako解压
        const jsonString = new TextDecoder('utf-8').decode(decompressed);
        const data = JSON.parse(jsonString); // 解析JSON字符串

        // 将数据存储到 dynamicVariable 中
        dynamicVariable[dataset.id + '_' + dataset.type] = data;
      }else if (dataset.way == 3) {
        const params = new URLSearchParams({
          id: dataset.id
        });

        const response = await fetch(config.apiUrl + `std_getCoordinate.php?${params}`);
        const arrayBuffer = await response.arrayBuffer();

        const compressed = new Uint8Array(arrayBuffer);
        const decompressed = pako.ungzip(compressed); // 使用pako解压
        const jsonString = new TextDecoder('utf-8').decode(decompressed);
        const data = JSON.parse(jsonString); // 解析JSON字符串

        // 将数据存储到 dynamicVariable 中
        dynamicVariable[dataset.id + '_' + dataset.type] = data;
      }
    });

    // 等待所有 Promise 完成
    await Promise.all(fetchPromises);

    // 执行用户输入的代码
    const code = codeEditor.getValue(); // 获取用户输入的代码
    const func = new Function('dynamicVariable', 'Plotly', code); // 将 dynamicVariable 和 Plotly 作为参数传递
    func(dynamicVariable, Plotly); // 执行函数并传递参数

    // 提示执行成功
    TerminalApi.pushMessage('ssMOOD', {
      class: 'system',
      tag: 'success',
      content: t('ap26')  // 执行成功
    });
  } catch (error) {
    // 提示执行失败
    TerminalApi.pushMessage('ssMOOD', {
      class: 'system',
      tag: 'fail',
      content: t('ap30') + error  // 执行代码时出错
    });
    console.error("执行代码时出错:", error);
  }
};
// 代码编辑器相关
const editor = ref(null)
let codeEditor = null
const codeContent = ref('// 生成的代码将出现在这里\n')
const modalPosition = ref({
  top: '0px',
  left: '0px'
})
let lastSelection = null
const modalRef = ref(null)
const showModal = ref(false)
const selectedCode = ref('')
const userInput2 = ref('')
// 更新模态窗位置

let selectionTimeout = null; // 用于存储定时器
const selectionDelay = 300; // 延迟300ms，判断是否完成选择

onMounted(() => {
  codeEditor = ace.edit(editor.value, {
    mode: 'ace/mode/javascript',
    theme: 'ace/theme/clouds',
    fontSize: 14,
    value: codeContent.value,
    useWorker: false
  })
  
  codeEditor.session.on('change', () => {
    codeContent.value = codeEditor.getValue()
  })
  
codeEditor.selection.on('changeSelection', () => {
  const selection = codeEditor.getSelection();
  const range = selection.getRange();
  
  // 如果没有选择内容，直接隐藏模态窗
  if (selection.$isEmpty) {
    showModal.value = false;
    return;
  }

  // 如果之前有定时器，先清除掉
  if (selectionTimeout) {
    clearTimeout(selectionTimeout);
  }

  // 延迟执行，等用户选择结束后再执行
  selectionTimeout = setTimeout(() => {
    const selectionText = codeEditor.getSelectedText();
    if (selectionText.length > 0) {
      selectedCode.value = selectionText; // 获取选中的文本
      showModal.value = true; // 显示模态窗
      lastSelection = range;
      updateModalPosition(); // 更新模态窗位置
    }
  }, selectionDelay);
});
  
})


const updateModalPosition = () => {
  if (!lastSelection || !codeEditor) return;

  // 获取选中结束位置的屏幕坐标
  const endPos = lastSelection.end;
  const screenPos = codeEditor.renderer.textToScreenCoordinates(endPos.row, endPos.column);

  // 转换为容器相对位置
  const containerRect = editor.value.getBoundingClientRect();
  const modalWidth = 280; // 模态窗固定宽度

  // 计算理想位置：将模态窗放在选中区域的右边
  let left = screenPos.pageX - containerRect.left; // 距离选中文本右侧15px
  let top = screenPos.pageY - containerRect.top;

  // 边界检测：确保模态窗不会超出编辑器的右边界
  const maxLeft = containerRect.width - modalWidth - 20;
  if (left > maxLeft) left = maxLeft;

  const maxTop = containerRect.height - 200; // 假设模态窗高度200px
  if (top > maxTop) top = maxTop;

  // 应用位置
  modalPosition.value = {
    top: `${top}px`,
    left: `${left}px`
  };

  // 延迟显示确保位置计算完成
  setTimeout(() => showModal.value = true, 50);
};


// 窗口变化时重新定位
window.addEventListener('resize', updateModalPosition)

//-------------------------------------
//局部代码编辑
//-------------------------------------

const handleSubmit = async () => {
  if (!userInput2.value.trim()) return;

  // 处理提交逻辑
  console.log('选中的代码:', selectedCode.value);
  console.log('用户输入:', userInput2.value);
  
  // 获取AI生成的代码
  const response = await partCodefetchOpenAI('需要修改的代码：' + selectedCode.value + "，用户要求：" + userInput2.value);
  const generatedCode = response.code;
  const cleanedCode = generatedCode.replace(/```javascript|```/g, '').trim();

  // 获取选中的范围
  const selection = codeEditor.getSelection();
  const range = selection.getRange();  // 获取当前选中的范围

  // 使用选中的范围进行替换
  if (!selection.isEmpty()) {
    const session = codeEditor.session; // 定义 session
    session.replace(range, cleanedCode); // 替换选中的内容
  }

  // 执行其他逻辑（如果有）
  handleExe();
  
  closeModal();  // 关闭模态窗
  userInput2.value = '';  // 清空用户输入
};


const closeModal = () => {
  showModal.value = false
  codeEditor.clearSelection() // 清除编辑器选中状态
}



// 发送请求到 OpenAI，并获取代码
const partCodefetchOpenAI = async (userMessage) => {
    
    
    const systemMessage = `你是一个专业的JavaScript程序员，请始终以代码块形式返回代码，用户给出一段代码，按要求修改，仅返回修改后的部分，按原代码格式返回，如果原代码有空格等符号也要返回，只生成代码不要解释。如果需要绘图使用plotly库，将图片绘制到myCanvas元素，仅返回js代码，不返回html元素。注意：1. Plotly的layout配置中必须设置autosize: true，禁止设置固定的width和height属性，图表会自动适应容器大小。2. 禁止使用Plotly.makeSubplots函数，因为该函数在plotly.js-dist-min中不可用。3. 如需多子图，可以使用layout中annotations或shapes属性手动布局。4. 确保所有数据引用的变量都正确来源于dynamicVariable对象。`;
    
    // 使用 Vue 的 ref 来存储聊天记录
    const chatHistory = ref([{ role: 'system', content: systemMessage }]);
  // 将用户消息添加到聊天记录
  chatHistory.value.push({ role: 'user', content: userMessage });

  try {
    // 发送请求到后端 (PHP)
    const response = await axios.post(config.apiUrl + 'openai_proxy.php', {
      messages: chatHistory.value // 发送聊天记录
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // 处理并返回 OpenAI 响应
    const { choices } = response.data;
    const code = choices && choices[0] ? choices[0].message.content : '';
    // 返回生成的代码和完整的 OpenAI 响应
    return {
      code, // 返回生成的代码
      rawResponse: response.data, // 返回完整的 OpenAI API 响应
    };

  } catch (error) {
    console.error('API调用失败:', error);
    throw new Error(`生成失败: ${error.message}`);
  }
};
//-------------------------------------
//数据集管理
//-------------------------------------

const SC_datasets = ref([]);

onMounted(async () => {
  try {
    const response = await axios.post(config.apiUrl + 'ap_getDatasetList_sc.php'); // 假设这是你的后端接口
    SC_datasets.value = response.data.datasets;
  } catch (error) {
    console.error('Error fetching datasets:', error);
  }
});
const ST_datasets = ref([]);

onMounted(async () => {
  try {
    const response = await axios.post(config.apiUrl + 'ap_getDatasetList_st.php'); // 假设这是你的后端接口
    ST_datasets.value = response.data.datasets;
  } catch (error) {
    console.error('Error fetching datasets:', error);
  }
});

const selectedDataType = ref("");
const showDatasetSelect = ref();
watch(selectedDataType, (newVal) => {
    if(newVal==="1"){
        showDatasetSelect.value = 1;
    }else if(newVal==="2"){
        showDatasetSelect.value = 2;
    }else if(newVal==="3"){
        showDatasetSelect.value = 3;
    }else if(newVal==="4"){
        showDatasetSelect.value = 4;
    }
      
});
    

const selectedId1 = ref('');
const selectedId2 = ref('');
const selectedId3 = ref('');
const selectedId4 = ref('');
const selectedType1 = ref('');
const selectedType2 = ref('');


const selectedGene_SC = ref('');
const selectedGene_ST = ref('');

const datasets = ref([]);

const addDataset = (way) => {
  if (way==1)    
  {
    if (selectedId1.value && selectedType1.value) {
    datasets.value.push({
      type: selectedType1.value,
      id: selectedId1.value,
      way:way
    });
    selectedType1.value = '';
    selectedId1.value = '';
  }
  }
  else if (way==2){
    if (selectedId2.value && selectedGene_SC.value) {
    datasets.value.push({
      type: selectedGene_SC.value,
      id: selectedId2.value,
      way:way
    });
    selectedGene_SC.value = '';
    selectedId2.value = '';
  }
  }
    else if (way==3)    
  {
    if (selectedId3.value && selectedType2.value) {
    datasets.value.push({
      type: selectedType2.value,
      id: selectedId3.value,
      way:way
    });
    selectedType2.value = '';
    selectedId3.value = '';
  }
  }
 else if (way==4){
    if (selectedId4.value && selectedGene_ST.value) {
    datasets.value.push({
      type: selectedGene_ST.value,
      id: selectedId4.value,
      way:way
    });
    selectedGene_ST.value = '';
    selectedId4.value = '';
  }
  }

};

const removeDataset = (index) => {
  datasets.value.splice(index, 1);
};


//-------------------------------------
//聊天相关
//-------------------------------------
const chatMessages = ref([])
const userInput = ref('')
const isLoading2 = ref(false)
const prompt = ref('')
let abortController = null

const stopExecution = () => {
  if (abortController) {
    abortController.abort();
    abortController = null;
  }
}

const sendMessage = async () => {
  // 如果正在执行，点击停止
  if (isLoading2.value) {
    stopExecution();
    chatMessages.value.push({
      role: 'assistant',
      content: t('ap29')  // 已停止执行
    });
    isLoading2.value = false;
    return;
  }
  
  if (!userInput.value.trim()) return

  // 检查是否选择了数据集
  if (!datasets.value || datasets.value.length === 0) {
    chatMessages.value.push({
      role: 'assistant',
      content: t('ap28')  // 请先选择您需要分析的数据集
    })
    userInput.value = ''
    return
  }

  chatMessages.value.push({ 
    role: 'user', 
    content: userInput.value 
  })
  

   if (datasets.value && datasets.value.length > 0) {
      prompt.value = codeEditor.getValue()+"用户需求："+userInput.value
      datasets.value.forEach((dataset) => {
        console.log(`数据集ID: ${dataset.id}, 类型: ${dataset.type}, 方法: ${dataset.way}`);
        if(dataset.way==1){
            prompt.value=`用户在 dynamicVariable[${dataset.id}_${dataset.type}] 变量中，已存在以下格式的 JSON 数组：{
  "umap_data": [
    {
      "i": "cell1", // 细胞 ID
      "u1": 1.23,   // UMAP 维度 1
      "u2": 4.56,   // UMAP 维度 2
      "c": "cluster1" // 分类标签
    }
  ],
  "cluster_labels": [
    "cluster1",
    "cluster2"
  ]
}。这些内容已定义，无需重新定义。
【重要】请参考以下标准绘图代码模板来生成代码，确保按cluster正确区分颜色：
\`\`\`javascript
// 提取数据
const umapData = dynamicVariable['xxx_umap'].umap_data;
const clusterLabels = dynamicVariable['xxx_umap'].cluster_labels;

// 准备 Plotly 数据 - 按 cluster 分组
const traces = clusterLabels.map(cluster => {
  const clusterData = umapData.filter(d => d.c === cluster);
  return {
    x: clusterData.map(d => d.u1),
    y: clusterData.map(d => d.u2),
    mode: 'markers',
    type: 'scatter',
    name: cluster,
    marker: { size: 5 }
  };
});

// 配置布局
const layout = {
  title: 'UMAP可视化',
  xaxis: { title: 'UMAP1' },
  yaxis: { title: 'UMAP2' }
};

// 渲染图表
Plotly.newPlot('myCanvas', traces, layout);
\`\`\`
`+prompt.value
    }else if(dataset.way==3){
         prompt.value=`用户在 dynamicVariable[${dataset.id}_${dataset.type}] 变量中，已存在以下格式的空转坐标 JSON 数组：{
  "coordinate_data": [
    {
      "i": "cell1", // 细胞 ID
      "x": 1.23,   // x_coordinate
      "y": 4.56,   // y_coordinate
      "c": "cluster1" // 分类标签
    }
  ],
  "cluster_labels": [
    "cluster1",
    "cluster2"
  ]
}。这些内容已定义，无需重新定义。
【重要】请参考以下标准绘图代码模板来生成代码，确保按cluster正确区分颜色：
\`\`\`javascript
// 提取数据
const coordData = dynamicVariable['xxx_spatial'].coordinate_data;
const clusterLabels = dynamicVariable['xxx_spatial'].cluster_labels;

// 准备 Plotly 数据 - 按 cluster 分组
const traces = clusterLabels.map(cluster => {
  const clusterData = coordData.filter(d => d.c === cluster);
  return {
    x: clusterData.map(d => d.x),
    y: clusterData.map(d => d.y),
    mode: 'markers',
    type: 'scatter',
    name: cluster,
    marker: { size: 5 }
  };
});

// 配置布局
const layout = {
  title: '空间坐标可视化',
  xaxis: { title: 'X' },
  yaxis: { title: 'Y' }
};

// 渲染图表
Plotly.newPlot('myCanvas', traces, layout);
\`\`\`
`+prompt.value
    }
       });
      
      userInput.value = ''
      isLoading2.value = true
      abortController = new AbortController();

      // 添加临时加载消息
      const loadingMsgIndex = chatMessages.value.length;
      chatMessages.value.push({ role: 'assistant', content: t('ap32') });  // 🤖 AI 正在处理...

      try {
        const response = await fetchOpenAI(prompt.value, abortController.signal) // 替换为你的API调用
        prompt.value=""
        console.log(response)

        // 检查是否为不相关问题
        if (response.isIrrelevant) {
          // 替换加载消息为帮助消息
          chatMessages.value[loadingMsgIndex] = {
            role: 'assistant',
            content: response.irrelevantMsg  // 显示帮助消息
          };
        } else {
          const generatedCode = response.code
          // 替换加载消息为成功消息
          chatMessages.value[loadingMsgIndex] = {
            role: 'assistant',
            content: t('ap26')  // 执行成功
          };
          const cleanedCode = generatedCode.replace(/```javascript|```/g, '').trim();
          codeEditor.setValue(cleanedCode);
          codeEditor.clearSelection();
          handleExe();
        }
      } catch (error) {
        // 判断是否为取消请求
        if (axios.isCancel(error)) {
          // 用户取消了请求，移除加载消息
          chatMessages.value.splice(loadingMsgIndex, 1);
        } else {
          // 替换加载消息为失败消息
          chatMessages.value[loadingMsgIndex] = {
            role: 'assistant',
            content: t('ap27')  // 执行失败，请重新输入指令
          };
          terminalLogs.value.push({ type: 'error', content: `API错误: ${error.message}` })
        }
      } finally {
        isLoading2.value = false
        abortController = null;
      }
    }
    else{
        console.error("没有选择数据集");
    }
}

// 快捷命令发送函数
const sendQuickCommand = (type) => {
  let command = '';
  switch (type) {
    case 'umap':
      command = t('ap37');  // 根据所选数据生成UMAP图
      break;
    case 'spatial':
      command = t('ap38');  // 根据所选数据生成空间位置图
      break;
    case 'histogram':
      command = t('ap39');  // 根据数据生成直方图
      break;
  }
  userInput.value = command;
  sendMessage();
}



//-------------------------------------
//openai接口
//-------------------------------------


const systemMessage = `你是一个专业的JavaScript绘图程序员，请始终以代码块形式返回代码，每次用户提出要求后都需要给出完整的代码，不要只给出更改的部分，只生成代码不要解释。如果需要绘图使用plotly库，将图片绘制到myCanvas元素，仅返回js代码，不返回html元素。注意：1. Plotly的layout配置中必须设置autosize: true，禁止设置固定的width和height属性，图表会自动适应容器大小。2. 禁止使用Plotly.makeSubplots函数，因为该函数在plotly.js-dist-min中不可用。3. 如需多子图，可以使用layout中annotations或shapes属性手动布局。4. 确保所有数据引用的变量都正确来源于dynamicVariable对象。5. 【重要】意图判断规则：如果用户的问题与单细胞数据分析、UMAP可视化、基因表达、聚类分布、差异表达、颜色范围调整、图表修改等完全无关（例如：天气、新闻、笑话、股票、一般性聊天），请不要生成任何代码，而是直接输出一行纯文本：__IRRELEVANT__`;

// 使用 Vue 的 ref 来存储聊天记录
const chatHistory = ref([{ role: 'system', content: systemMessage }]);

// 发送请求到 OpenAI，并获取代码
const fetchOpenAI = async (userMessage, signal) => {
  // 重新初始化聊天记录，使用当前语言设置的系统消息
  chatHistory.value = [{ role: 'system', content: systemMessage }];
  // 将用户消息添加到聊天记录
  chatHistory.value.push({ role: 'user', content: userMessage });

  try {
    // 发送请求到后端 (PHP)
    const response = await axios.post(config.apiUrl + 'openai_proxy.php', {
      messages: chatHistory.value // 发送聊天记录
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      signal: signal // 支持取消请求
    });

    // 处理并返回 OpenAI 响应
    const { choices } = response.data;
    const code = choices && choices[0] ? choices[0].message.content : '';

    // 检查是否为不相关问题
    const isIrrelevant = code.includes('__IRRELEVANT__');

    // 将 OpenAI 的响应（助手的回复）加入聊天记录
    chatHistory.value.push({ role: 'assistant', content: code });

    // 保证聊天记录最多保存10条
    if (chatHistory.value.length > 10) {
      chatHistory.value.shift(); // 删除最早的记录
    }

    // 返回生成的代码和完整的 OpenAI 响应
    return {
      code: isIrrelevant ? '' : code,  // 如果是不相关问题，返回空代码
      isIrrelevant,  // 标记是否为不相关问题
      irrelevantMsg: isIrrelevant ? t('ap33') : '',  // 不相关问题的帮助消息
      rawResponse: response.data, // 返回完整的 OpenAI API 响应
      chatHistory // 返回当前聊天记录
    };

  } catch (error) {
    console.error('API调用失败:', error);
    throw new Error(`生成失败: ${error.message}`);
  }
};





//-------------------------------------
//工具栏
//-------------------------------------
//const isFullscreen = ref(false)

/*
const toggleFullscreen = () => {
  isFullscreen.value = !isFullscreen.value
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen()
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    }
  }
}
*/
//-------------------------------------
//工具栏拖动
//-------------------------------------



</script>

<style scoped>
@import 'css/MainStyles.css';
.page-section {
  padding: 0px;
  flex: 1; /* 占据剩余的空间 */
}
.container {
  display: flex;
  height: 92vh;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
}

.panel {
  flex: 1;
  min-width: 0;
  padding: 12px;
  border-radius: 16px;
}

.chat-panel {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(93, 116, 162, 0.12);
  margin: 8px;
  margin-right: 6px;
  overflow: hidden;
}

.left-panel {
  display: flex;
  flex-direction: column;
  flex: 2;
  margin: 8px;
  margin-left: 6px;
}

.preview-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  height:100%;
  gap:16px;
}

.image-preview {
  flex: 1;
  border: none;
  padding: 16px;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(93, 116, 162, 0.15);
  background: #fff;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.image-preview:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(93, 116, 162, 0.25);
}

/* ############################## */
/* 代码编辑器样式 */
/* ############################## */
.editor-panel{
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  flex-direction: column;
  gap:10px;
}


.code-editor {

  width: 95%; /* 占满父容器的宽度 */
  height: 85%; /* 占满父容器的高度 */
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(93, 116, 162, 0.15);
  padding: 10px;
  font-family: monospace;
  font-size: 14px;
  white-space: pre-wrap;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  background: #fff;
  transition: all 0.3s ease;
}

.code-editor:hover {
  box-shadow: 0 4px 12px rgba(93, 116, 162, 0.25);
}
/* ############################## */
/* 数据集管理面板 */
/* ############################## */
.dataset-panel {
  background: linear-gradient(145deg, #ffffff, #f8f9fb);
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 20px rgba(93, 116, 162, 0.08);
  border: 1px solid rgba(93, 116, 162, 0.1);
}

.dataset-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.dataset-panel-header h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #5d74a2;
  margin: 0;
}

.manage-btn {
  padding: 4px 12px;
  background: #5d74a2;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

.manage-btn:hover {
  background: #4a5f8a;
}

.dataset-add-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 12px;
}

.dataset-select {
  flex: 1;
  min-width: 80px;
  padding: 10px 14px;
  border: 2px solid #e8ecf2;
  border-radius: 10px;
  font-size: 13px;
  background: #fff;
  color: #5d74a2;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dataset-select:focus {
  outline: none;
  border-color: #5d74a2;
  box-shadow: 0 0 0 3px rgba(93, 116, 162, 0.15);
}

.dataset-select:first-child {
  max-width: 120px;
  flex: 0 0 auto;
}

.add-btn {
  padding: 10px 20px;
  background: linear-gradient(135deg, #5d74a2, #7a8fc4);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(93, 116, 162, 0.3);
}

.add-btn:hover {
  background: linear-gradient(135deg, #4a5f8a, #6b7fb0);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(93, 116, 162, 0.4);
}

.add-btn:disabled {
  background: linear-gradient(135deg, #c8cdd6, #d8dde4);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.dataset-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.dataset-tag {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #e8f4fd, #d4ecf9);
  border: 1px solid #b8daef;
  border-radius: 12px;
  font-size: 12px;
  color: #2c5aa0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease;
}

.dataset-tag:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(93, 116, 162, 0.2);
}

.remove-tag {
  cursor: pointer;
  font-weight: bold;
  color: #e74c3c;
  margin-left: auto;
  flex-shrink: 0;
  font-size: 14px;
  transition: all 0.2s ease;
}

.remove-tag:hover {
  color: #c0392b;
  transform: scale(1.2);
}

.no-dataset {
  color: #999;
  font-size: 13px;
}

/* ############################## */
/* 聊天信息容器 */
/* ############################## */
.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 12px;
  padding: 4px;
}

.chat-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 8px;
  text-align: center;
  color: #5d74a2;
  background: linear-gradient(135deg, #5d74a2, #7a8fc4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: none;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: linear-gradient(180deg, #fafbfc, #f5f7fa);
  border-radius: 16px;
  box-shadow: inset 0 2px 8px rgba(93, 116, 162, 0.08);
  border: 1px solid rgba(93, 116, 162, 0.08);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.chat-messages:hover {
  box-shadow: 0 4px 12px rgba(93, 116, 162, 0.25);
}
/* 滚动条美化 */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: rgba(93, 116, 162, 0.3);
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: rgba(93, 116, 162, 0.5);
}
.message {
  margin: 12px 0;
  padding: 14px 18px;
  border-radius: 18px;
  max-width: 75%;
  box-shadow: 0 2px 8px rgba(93, 116, 162, 0.1);
  font-size: 14px;
  line-height: 1.6;
  position: relative;
  display: block;
  width: fit-content;
  animation: messageSlide 0.3s ease;
}

@keyframes messageSlide {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message.user {
  background: linear-gradient(135deg, #5d74a2, #6b7fb0);
  margin-left: auto;
  margin-right: 8px;
  color: #fff;
  text-align: left;
  border: none;
  border-radius: 18px 18px 4px 18px;
}

.message.assistant {
  background: #fff;
  margin-left: 8px;
  margin-right: auto;
  color: #444;
  text-align: left;
  border: 1px solid rgba(93, 116, 162, 0.15);
  border-radius: 18px 18px 18px 4px;
}

/* ############################## */
/* 用户输入 */
/* ############################## */
.chat-input-container {
  display: flex;
  justify-content: center;
  padding: 4px 0;
}
.chat-input {
  display: inline-flex;
  width: fit-content;
  padding: 10px 14px;
  background: #fff;
  border-radius: 50px;
  box-shadow: 0 4px 20px rgba(93, 116, 162, 0.15);
  border: 2px solid rgba(93, 116, 162, 0.1);
  gap: 10px;
  transition: all 0.3s ease;
}

.chat-input:hover {
  box-shadow: 0 6px 24px rgba(93, 116, 162, 0.25);
  border-color: rgba(93, 116, 162, 0.2);
}

.chat-input input {
  padding: 12px 16px;
  border: 2px solid #e8ecf2;
  border-radius: 25px;
  background-color: #f8f9fb;
  color: #333;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  width: 450px;
  max-width: 450px;
}

.chat-input input:focus {
  width: 450px;
  max-width: 450px;
  border-color: #5d74a2;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(93, 116, 162, 0.1);
}

.chat-input input::placeholder {
  color: #aaa;
}

.chat-input button {
  padding: 12px 24px;
  border: none;
  background: linear-gradient(135deg, #5d74a2, #7a8fc4);
  color: white;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(93, 116, 162, 0.35);
}

.chat-input button:hover {
  background: linear-gradient(135deg, #4a5f8a, #6b7fb0);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(93, 116, 162, 0.45);
}

.chat-input button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(93, 116, 162, 0.3);
}

.chat-input button.stop-btn {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.4);
}

.chat-input button.stop-btn:hover {
  background: linear-gradient(135deg, #c0392b, #a93226);
  box-shadow: 0 6px 20px rgba(231, 76, 60, 0.5);
}

/* 快捷功能按钮 */
.quick-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 10px 0;
}

.quick-btn {
  padding: 8px 16px;
  border: 1px solid rgba(93, 116, 162, 0.3);
  background: linear-gradient(135deg, #f8f9fb, #e8ecf2);
  color: #5d74a2;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.quick-btn:hover {
  background: linear-gradient(135deg, #5d74a2, #7a8fc4);
  color: white;
  border-color: #5d74a2;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(93, 116, 162, 0.3);
}

.quick-btn:active {
  transform: translateY(0);
}



/* ############################## */
/* 浮动工具栏 */
/* ############################## */
.floating-toolbar:dragging {
  z-index: 9999;
}

.floating-toolbar {
  align-items: center;
  justify-content: center;
  background: rgba(93, 116, 162, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(93, 116, 162, 0.15);
  border: 1px solid rgba(93, 116, 162, 0.2);
  display: inline-flex;
  width: fit-content;
  transition: all 0.3s ease;
}

.floating-toolbar:hover {
  box-shadow: 0 4px 12px rgba(93, 116, 162, 0.25);
  transform: translateY(-1px);
}

.toolbar-content {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  flex-wrap: nowrap;
}

.toolbar-btn {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  background: #fff;
  border: 1px solid rgba(93, 116, 162, 0.2);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #5d74a2;
  font-size: 14px;
  font-weight: 500;
}

.toolbar-btn:hover {
  background: rgba(93, 116, 162, 0.1);
  transform: translateY(-1px);
  border-color: rgba(93, 116, 162, 0.4);
  box-shadow: 0 2px 6px rgba(93, 116, 162, 0.2);
}

.toolbar-btn:active {
  transform: translateY(1px);
}

.icon {
  margin-right: 6px;
  font-size: 14px;
}

.divider {
  width: 1px;
  height: 20px;
  background: rgba(93, 116, 162, 0.2);
  margin: 0 6px;
}

.execute-btn {
  padding: 8px 60px;
  min-width: 160px;
  font-weight: 600;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .floating-toolbar {
    padding: 6px 8px;
  }

  .toolbar-btn {
    padding: 6px 10px;
    font-size: 12px;
  }

  .icon {
    font-size: 12px;
  }
}

/* ############################## */
/* ai模态窗 */
/* ############################## */


/* 模态窗遮罩层 */
.context-modal {
  position: absolute;
  width: 320px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(93, 116, 162, 0.2);
  border: 1px solid rgba(93, 116, 162, 0.2);
  z-index: 1000;
  transform-origin: left top;
  animation: slideIn 0.25s ease-out;
}

/* 模态窗容器 */
.modal-container {
  max-width: 320px;
  backdrop-filter: blur(10px);
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(93, 116, 162, 0.2);
  border: 1px solid rgba(93, 116, 162, 0.2);
  overflow: hidden;
}

/* 模态窗头部 */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  background: rgba(93, 116, 162, 0.05);
}

.modal-header h3 {
  margin: 0;
  font-weight: 600;
  color: #5d74a2;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0 8px;
  transition: color 0.3s ease;
}

.close-btn:hover {
  color: #5d74a2;
}

/* 内容区域 */
.modal-content {
  padding: 16px;
}

.selected-code {
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
  max-height: 150px;
  overflow: auto;
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  color:black;
}

.selected-code pre {
  margin: 0;
  font-family: 'Menlo', monospace;
  font-size: 13px;
  color: #333;
}

/* 输入区域 */
.input-group {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.ios-input {
  flex: 1;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  min-height: 80px;
  font-family: -apple-system, sans-serif;
  font-size: 14px;
  resize: none;
  transition: border-color 0.3s ease;
}

.ios-input:focus {
  outline: none;
  border-color: #5d74a2;
}

.ios-button {
  background: rgb(93, 116, 162);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ios-button:hover {
  background: rgba(93, 116, 162, 0.8);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(93, 116, 162, 0.3);
}

.ios-button:active {
  transform: translateY(1px);
}

/* 动画效果 */
.modal-container {
  animation: modalEnter 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes modalEnter {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* ############################## */
/* 数据集管理模态窗 */
/* ############################## */

.dataset-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1002;
}

.dataset-modal-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  width: 50vw;
  max-width: 90%;
  box-shadow: 0 8px 24px rgba(93, 116, 162, 0.2);
}
.dataset-modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    width: 100%;
    border-bottom: 1px solid #e0e0e0;
}

.dataset-modal-header h2 {
    position: relative;
    margin: 0;
    font-size: 1.4rem;
    text-align: center;
    color: #5d74a2;
    font-weight: 600;
}

.dataset-modal-header button {
    margin: 0;
    padding: 5px 10px;
    margin-left: auto;
    font-size: 1rem;
    cursor: pointer;
    border: none;
    background-color: transparent;
    color: #999;
    transition: color 0.3s ease;
}

.dataset-modal-header button:hover {
  color: #5d74a2;
}
.add-dataset-content {
    border: 1px solid #e0e0e0;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 8px;
    background-color: #f8f9fa;
    width: 80%;
    justify-content: center;
    display: flex;
    flex-direction: column;
}


.add-dataset-content h3{
     display: flex;
    margin: 0;
    justify-content: center;
    color: #5d74a2;
    font-weight: 600;
    margin-bottom: 10px;
}
.add-dataset-div{
    display: flex;
    flex-direction: row;
    gap: 10px;

}

.add-dataset {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}


.add-dataset select {
    padding: 8px 12px;
    font-size: 14px;
    color: #333;
    outline: none;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.3s ease;
}

.add-dataset select:focus {
  border-color: #5d74a2;
}

.add-dataset button {
    margin: 0;
    padding: 8px 14px;
    margin-left: auto;
    font-size: 14px;
    cursor: pointer;
    border: none;
    border-radius: 8px;
    background: rgb(93, 116, 162);
    color: white;
    font-weight: 500;
    transition: all 0.3s ease;
}

.add-dataset button:hover {
  background: rgba(93, 116, 162, 0.8);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(93, 116, 162, 0.3);
}

.dataset-list {
    display: flex;
    list-style: none;
    padding: 0;
    width: 80%;
    flex-direction: column;
    gap: 8px;
}

.dataset-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  transition: all 0.3s ease;
}

.dataset-list li:hover {
  background: rgba(93, 116, 162, 0.05);
  border-color: rgba(93, 116, 162, 0.3);
}

.dataset-list button{
    margin: 0;
    padding: 6px 12px;
    margin-left: auto;
    font-size: 14px;
    cursor: pointer;
    border: none;
    border-radius: 6px;
    background: #f8f9fa;
    color: #666;
    transition: all 0.3s ease;
}

.dataset-list button:hover {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}
</style>
